export interface GroupDiningRequest {
    Personal: Personal;
    HowHeard?: string;
    IsTaxExempt: boolean;
    AccountingContact: AccountingContact;
    Recipients: Recipient[];
    IsTermConditions: boolean;
    OrganizationTaxId: string;
}
export interface Contact {
    FirstName: string;
    MiddleName?: string;
    LastName: string;
    Email: string;
    Phone: string;
}

export interface AccountingContact extends Contact {
    Fax: string;
}

export interface Recipient {
    Name?: string;
    Title?: string;
}

export interface Organization {
    Name: string;
    Type: string;
}

export interface Personal extends Contact {
    Organization: Organization;
    Address: Address;
}

export class Address {
    line1: string;
    line2: string;
    city: string;
    state: string;
    zipCode: string;
}
